export default function (totalCharge, quantity, card) {
  gtag("event", "conversion", {
    send_to: "AW-11394969496/IMUTCLCnotQZEJjfxbkq",
    value: totalCharge,
    currency: "USD",
    transaction_id: card?.id,
  });
  gtag("event", "conversion", {
    send_to: "AW-11394969496/10ZSCOquqdQZEJjfxbkq",
  });
}
